import { toast } from "react-toastify";

const errorHandler = (error = null, customMessage) => {
    const defaultMessage = "Something went wrong! Please try again.";

    if (!error) {
        toast.error(defaultMessage, { position: "top-center" });
        return;
    }
    const entries = Object.entries(error?.data?.errors ?? {});
    const [[, firstValue] = []] = entries;
    const legacyErrorMessage = Array.isArray(firstValue) && firstValue[0];

    const errorMap = {
        apiError: error?.error?.data?.message,
        responseError: error?.data?.message ?? error?.data?.title,
        responseErrorNested: error?.error?.data?.message,
        generalError: error?.message,
    };

    const message = customMessage || legacyErrorMessage || Object.values(errorMap).find((msg) => msg) || defaultMessage;

    toast.error(message, { position: "top-center" });
};

export default errorHandler;
